module.exports = __webpack_public_path__ + "common/react/audio/short-beeps.ogg";